import { render, staticRenderFns } from "./ProgramChrome.vue?vue&type=template&id=8c65f538&scoped=true&"
import script from "./ProgramChrome.vue?vue&type=script&lang=js&"
export * from "./ProgramChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c65f538",
  null
  
)

export default component.exports